import styled from 'styled-components';

import { DatePicker as DatePickerComponent } from 'components/date-picker';

// Inline in a filter panel: the shared picker's phone rule (height: 100vh,
// meant for the full-screen popup) left ~340px of blank space under the
// calendar, pushing the next filter below the fold.
export const DatePicker: typeof DatePickerComponent = styled(
  DatePickerComponent
)`
  .react-datepicker {
    padding: 0;
    height: auto;
  }
`;
